import type { Gig } from '@/mocks/gigs';

export interface GigDbRow {
  id: string;
  owner_id: string;
  title: string;
  freelancer: string | null;
  category: string | null;
  subcategory: string | null;
  price: number | null;
  delivery_days: number | null;
  rating: number | null;
  reviews_count: number | null;
  location: string | null;
  description: string | null;
  deliverables: string | null;
  created_at: string | null;
}

const fallbackCover =
  'https://readdy.ai/api/search-image?query=Modern%20freelance%20workspace%20with%20laptop%20showing%20creative%20project%2C%20clean%20minimal%20desk%2C%20warm%20natural%20lighting%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=gig-fallback-01&orientation=landscape';

const categoryCovers: Record<string, string> = {
  Développement:
    'https://readdy.ai/api/search-image?query=Developer%20coding%20on%20a%20laptop%20showing%20code%20editor%20interface%2C%20modern%20tech%20workspace%20with%20warm%20lighting%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20clean%20composition&width=800&height=500&seq=gig-cat-dev-01&orientation=landscape',
  Design:
    'https://readdy.ai/api/search-image?query=Graphic%20designer%20working%20with%20color%20palettes%20and%20a%20tablet%20in%20a%20modern%20creative%20studio%2C%20warm%20natural%20lighting%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=gig-cat-design-01&orientation=landscape',
  Marketing:
    'https://readdy.ai/api/search-image?query=Digital%20marketer%20analyzing%20campaign%20dashboards%20on%20a%20laptop%2C%20modern%20bright%20office%2C%20warm%20lighting%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=gig-cat-marketing-01&orientation=landscape',
  Rédaction:
    'https://readdy.ai/api/search-image?query=Writer%20typing%20on%20a%20laptop%20with%20notebook%20and%20coffee%20in%20a%20calm%20minimal%20workspace%2C%20warm%20natural%20light%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=gig-cat-writing-01&orientation=landscape',
  'Vidéo & Animation':
    'https://readdy.ai/api/search-image?query=Video%20editor%20working%20on%20motion%20graphics%20in%20editing%20software%20on%20a%20monitor%2C%20modern%20creative%20studio%2C%20warm%20lighting%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=gig-cat-video-01&orientation=landscape',
  Business:
    'https://readdy.ai/api/search-image?query=Business%20consultant%20presenting%20charts%20and%20strategy%20on%20a%20modern%20desk%2C%20professional%20office%20with%20warm%20lighting%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=gig-cat-business-01&orientation=landscape',
  'Data & IA':
    'https://readdy.ai/api/search-image?query=Data%20scientist%20working%20with%20dashboards%20and%20charts%20on%20a%20monitor%2C%20modern%20tech%20workspace%2C%20warm%20lighting%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=gig-cat-data-01&orientation=landscape',
  'Musique & Audio':
    'https://readdy.ai/api/search-image?query=Music%20producer%20at%20a%20mixing%20console%20in%20a%20modern%20recording%20studio%2C%20warm%20ambient%20lighting%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=gig-cat-music-01&orientation=landscape',
};

export function coverForCategory(category: string): string {
  return categoryCovers[category] || fallbackCover;
}

export function mapDbGig(row: GigDbRow): Gig {
  return {
    id: row.id,
    title: row.title,
    freelancer: row.freelancer || 'Freelancer',
    ownerId: row.owner_id,
    category: row.category || 'Développement',
    subcategory: row.subcategory || undefined,
    price: row.price !== null && row.price !== undefined ? Number(row.price) : null,
    deliveryDays: row.delivery_days !== null ? Number(row.delivery_days) : null,
    rating: row.rating !== null ? Number(row.rating) : null,
    reviewsCount: row.reviews_count !== null ? Number(row.reviews_count) : 0,
    location: row.location || 'À distance',
    description: row.description || '',
    deliverables: row.deliverables || '',
    cover: coverForCategory(row.category || ''),
    postedAt: row.created_at ? row.created_at.slice(0, 10) : '',
  };
}

export function formatGigPrice(price: number | null): string {
  if (price === null || price === undefined) return 'Sur devis';
  return `${price.toLocaleString('fr-FR')} FCFA`;
}